const stamp = value => new Date(value).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
const escapeText = value => String(value || '').replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
const fold = line => {
  const rows = []; let row = ''; let bytes = 0;
  for (const char of line) {
    const count = unescape(encodeURIComponent(char)).length;
    if (bytes + count > 75) { rows.push(row); row = ' '; bytes = 1; }
    row += char; bytes += count;
  }
  rows.push(row); return rows.join('\r\n');
};
export const canExport = event => !!(event && /^[a-f\d]{24}$/i.test(event.id) &&
  Number.isFinite(Date.parse(event.startAt)) && Number.isFinite(Date.parse(event.endAt)) && Date.parse(event.endAt) > Date.parse(event.startAt));
const details = (event, store) => ({
  title: `MHC appointment — ${event.customer}`,
  description: [`Salesperson: ${event.salesperson}`, `Store: ${store.name}`,
    'Personal calendar copy. Reschedules and cancellations must be updated manually.',
    event.contactId ? `https://www.mhccrm.com/crm/${encodeURIComponent(event.contactId)}` : 'https://www.mhccrm.com/crm/calendar'].join('\n')
});
export function googleCalendarUrl(event, store) {
  if (!canExport(event)) return '';
  const { title, description } = details(event, store);
  return 'https://calendar.google.com/calendar/render?' + new URLSearchParams({ action: 'TEMPLATE', text: title,
    dates: `${stamp(event.startAt)}/${stamp(event.endAt)}`, ctz: 'America/Chicago', details: description, location: store.name }).toString();
}
export function calendarFile(event, store, now = new Date()) {
  if (!canExport(event)) throw new Error('Appointment dates are unavailable. Refresh the calendar.');
  const { title, description } = details(event, store);
  return ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//MHC CRM//Store Calendar//EN', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT',
    `UID:mhc-appointment-${event.id}@mhccrm.com`, `DTSTAMP:${stamp(now)}`, `DTSTART:${stamp(event.startAt)}`, `DTEND:${stamp(event.endAt)}`,
    `SEQUENCE:${Number.isSafeInteger(event.version) && event.version >= 0 ? event.version : 0}`, 'CLASS:PRIVATE',
    `STATUS:${event.status === 'Cancelled' ? 'CANCELLED' : 'CONFIRMED'}`, `SUMMARY:${escapeText(title)}`,
    `DESCRIPTION:${escapeText(description)}`, `LOCATION:${escapeText(store.name)}`, 'END:VEVENT', 'END:VCALENDAR'].map(fold).join('\r\n') + '\r\n';
}
